import { render, staticRenderFns } from "./RepairPage.vue?vue&type=template&id=5ba4e6aa"
import script from "./RepairPage.vue?vue&type=script&lang=js"
export * from "./RepairPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports